import { t } from '../i18n.js';

export function createLoadingComponent() {
  const loadingContainer = document.createElement('div');
  loadingContainer.className = 'loading-container';
  
  loadingContainer.innerHTML = `
    <div class="loading-spinner"></div>
    <p>${t('searching_contacts')}</p>
  `;
  
  return loadingContainer;
} 